/*
 * Preview in 3D on the product page (blocks/hl-3d-preview): opens the 3D kitchen in a dialog on this page.
 * - Nothing 3D loads with the page: the 3D script and styles are fetched on the first opening (and warmed on hover,
 *   focus or touch of a button). Closing pauses the 3D (no frames, no heat); opening again is instant.
 * - The viewer starts on the variant selected on the page; when it closes, the variant chosen in 3D is applied
 *   through the theme's variant picker, so price, photos, URL and cart follow as if chosen on the page.
 * - Back (phone or browser) closes the dialog instead of leaving the page; Escape and the close button too.
 * - "Add N to cart" and "Download my lighting plan" in the 3D use the page's Island Planner (kept on the page, out of
 *   sight, for the products shown in 3D): same bundle prices, same cart drawer, same PDF. Without a planner on the
 *   page, the theme's own buy form is used with the 3D's quantity.
 */
(function () {
  var dataEl = document.querySelector('[data-hl3d-data]');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = D.catalog[0];
  var dlg = null, state = 'idle', chosen = null, opener = null, pushed = false, warmed = false, afterClose = null;

  /* ---------- the page's variant ---------- */
  function picker() { return document.querySelector('.product-information variant-picker') || document.querySelector('main variant-picker'); }
  function pageVariantId() {
    var input = document.querySelector('.product-information form[action*="/cart/add"] input[name="id"]') || document.querySelector('main form[action*="/cart/add"] input[name="id"]');
    return (input && input.value) || new URL(location.href).searchParams.get('variant') || String(D.variantId);
  }
  // Select a variant on the page the way a shopper would: tick each option in the theme's picker, then let the
  // last one trigger the picker's own update (one request, price, gallery and URL updated by the theme)
  function applyToPage(variantId) {
    if (!variantId || String(variantId) === String(pageVariantId())) return;
    var v = P.v.filter(function (x) { return String(x.id) === String(variantId); })[0], vp = picker();
    if (!v || !vp) return;
    var changed = [];
    P.o.forEach(function (opt, i) {
      var fs = vp.querySelector('fieldset[data-fieldset-index="' + i + '"]');
      if (fs) {
        var input = Array.prototype.filter.call(fs.querySelectorAll('input'), function (x) { return x.value === v.o[i]; })[0];
        if (input && !input.checked) changed.push(input);
        return;
      }
      var sel = vp.querySelectorAll('select')[i];
      if (sel && sel.value !== v.o[i]) { sel.value = v.o[i]; changed.push(sel); }
    });
    if (!changed.length) return;
    var last = changed.pop();
    changed.forEach(function (el) { if (el.tagName === 'INPUT') { if (vp.updateSelectedOption) vp.updateSelectedOption(el); else el.checked = true; } });
    if (last.tagName === 'INPUT') last.click(); else last.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function waitFor(test, ms) {
    return new Promise(function (ok) { var t0 = Date.now(); (function k() { if (test() || Date.now() - t0 > ms) ok(test()); else setTimeout(k, 60); })(); });
  }
  function planner() { return document.querySelector('[data-hl-planner][data-mode="product"]'); }
  // Put the 3D's island length and count into the page's planner (same rules, so the same layout exists there)
  function plannerTo(d) {
    var pl = planner(); if (!pl) return Promise.resolve(null);
    var range = pl.querySelector('[data-length]');
    if (range) { range.value = Math.round(d.L); range.dispatchEvent(new Event('input', { bubbles: true })); }
    return waitFor(function () { return true; }, 0).then(function () {
      var b = pl.querySelector('[data-configs] button[data-n="' + d.n + '"]');
      if (b && !b.disabled && b.getAttribute('aria-checked') !== 'true') b.click();
      return pl;
    });
  }
  function samePage(d) { applyToPage(d.variantId); return waitFor(function () { return String(pageVariantId()) === String(d.variantId); }, 5000); }
  function buy(d) {
    samePage(d).then(function () { return plannerTo(d); }).then(function (pl) {
      var add = pl && pl.querySelector('[data-add]'), label = pl && pl.querySelector('[data-add-label]');
      var right = label && (d.n === 1 ? /Add (1 |to cart)/.test(label.textContent) : label.textContent.indexOf('Add ' + d.n + ' ') === 0);
      if (add && !add.disabled && right) { add.click(); return; }
      // No planner (or another quantity): the theme's buy form with the 3D's quantity
      var set = document.querySelector('.hl-bundle [data-qty="' + d.n + '"]');
      if (set) set.click();
      else {
        var q = document.querySelector('.product-information [name="quantity"]');
        if (q) { q.value = d.n; q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var btn = document.querySelector('.product-information form[action*="/cart/add"] [name="add"]') || document.querySelector('.product-information form[action*="/cart/add"] button[type="submit"]');
      if (btn) btn.click();
    });
  }
  function plan(d) {
    var host = document.getElementById('hl3d');
    var done = function (err) { host.dispatchEvent(new CustomEvent('hl3d:plan-done', { detail: { error: !!err } })); };
    samePage(d).then(function () { return plannerTo(d); }).then(function (pl) {
      var b = pl && pl.querySelector('[data-pdf]'); if (!b) return done(true);
      // The planner's kitchen photo is lazy and out of sight: load it now for the PDF
      var photo = pl.querySelector('[data-photo]');
      if (photo) photo.loading = 'eager';
      return waitFor(function () { return !photo || photo.complete; }, 8000).then(function () {
        b.click();
        // The planner disables its button while it builds the PDF
        var lab = b.querySelector('[data-pdf-label]'), failed = function () { return lab && /try again/i.test(lab.textContent); };
        return waitFor(function () { return b.disabled; }, 800)
          .then(function () { return waitFor(function () { return !b.disabled || failed(); }, 60000); })
          .then(function (ok) { done(!ok || failed()); });
      });
    }).catch(done);
  }

  /* ---------- loading ---------- */
  function warm() {
    if (warmed) return; warmed = true;
    [['style', D.css], ['script', D.js]].forEach(function (r) { var l = document.createElement('link'); l.rel = 'preload'; l.as = r[0]; l.href = r[1]; document.head.appendChild(l); });
  }
  function load() {
    state = 'loading';
    var saved = window.HLPlan && window.HLPlan.saved && window.HLPlan.saved();
    window.HL3D = Object.assign({}, D, { variantId: pageVariantId(), islandIn: saved ? saved.L : null });
    var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = D.css;
    var go = function () {
      if (state !== 'loading') return; state = 'script';
      var s = document.createElement('script'); s.src = D.js; s.async = true;
      s.onload = function () { dlg.classList.add('is-loaded'); };
      s.onerror = function () { fail(); };
      document.body.appendChild(s);
    };
    css.onload = go; css.onerror = go; setTimeout(go, 4000);
    document.head.appendChild(css);
  }
  function fail() {
    state = 'failed';
    var w = dlg.querySelector('[data-wait] p');
    if (w) w.innerHTML = '<small>Preview in 3D</small><strong>The 3D preview could not load</strong><span style="color:rgba(255,255,255,.75);font-size:14px">Please check your connection and try again.</span>';
  }

  /* ---------- dialog ---------- */
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'hl3d-dialog';
    dlg.setAttribute('aria-label', 'Preview in 3D: ' + D.title);
    dlg.innerHTML = '<div class="hl3d-dialog__box"><div id="hl3d"></div>' +
      '<div class="hl3d-dialog__wait" data-wait><p><small>Preview in 3D</small><strong>' + esc(D.title) + '</strong><i></i></p>' +
      '<button type="button" class="hl3d-dialog__x" data-x aria-label="Close the 3D preview">&times;</button></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); requestClose(); });
    dlg.addEventListener('hl3d:close', requestClose);
    dlg.addEventListener('hl3d:variant', function (e) { chosen = e.detail && e.detail.variantId; });
    // Add to cart: back to the page first, so the cart drawer opens over the product
    dlg.addEventListener('hl3d:buy', function (e) { var d = e.detail; afterClose = function () { buy(d); }; requestClose(); });
    dlg.addEventListener('hl3d:plan', function (e) { plan(e.detail); });
    dlg.addEventListener('hl3d:ready', function () {
      state = 'ready'; dlg.classList.add('is-loaded');
      // Closed while it was loading: stay paused until the next opening
      if (!dlg.open) { window.HL3DApp.pause(true); return; }
      var x = dlg.querySelector('#hl3d .hl3d-close'); if (x) x.focus({ preventScroll: true });
    });
    dlg.addEventListener('hl3d:fail', function () { state = 'failed'; dlg.classList.add('is-loaded'); });
    dlg.querySelector('[data-x]').addEventListener('click', requestClose);
    // A click on the dimmed page around the dialog (large screens) closes it
    dlg.addEventListener('click', function (e) { if (e.target === dlg) requestClose(); });
  }
  function open(e) {
    opener = e && e.currentTarget;
    if (!dlg) build();
    if (dlg.open) return;
    document.documentElement.classList.add('hl3d-locked');
    dlg.showModal();
    try { history.pushState({ hl3d: 1 }, ''); pushed = true; } catch (err) { pushed = false; }
    if (state === 'idle') load();
    else if (state === 'failed') { state = 'idle'; dlg.classList.remove('is-loaded'); load(); }
    else if (window.HL3DApp) {
      window.HL3DApp.pause(false);
      var id = pageVariantId(), cur = window.HL3DApp.current();
      if (cur && String(cur.variantId) !== String(id)) window.HL3DApp.select(id);
      var x = dlg.querySelector('#hl3d .hl3d-close'); if (x) x.focus({ preventScroll: true });
    }
  }
  function requestClose() {
    if (!dlg || !dlg.open) return;
    // Our history entry first, so Back and the close button end in the same place
    if (pushed && history.state && history.state.hl3d) history.back(); else close();
  }
  function close() {
    pushed = false;
    if (!dlg || !dlg.open) return;
    if (window.HL3DApp) window.HL3DApp.pause(true);
    dlg.close();
    document.documentElement.classList.remove('hl3d-locked');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    var next = afterClose; afterClose = null;
    if (next) next(); else applyToPage(chosen);
  }
  window.addEventListener('popstate', function () { if (dlg && dlg.open) close(); });

  /* ---------- buttons ---------- */
  function bind(btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(e); });
    ['pointerenter', 'focus', 'touchstart'].forEach(function (t) { btn.addEventListener(t, warm, { passive: true, once: true }); });
  }
  document.querySelectorAll('[data-hl3d-open]').forEach(bind);
  // On these products the Island Planner lives in the 3D: links to it open the 3D
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#island-planner"], a[href="#specifications"]');
    if (!a || a.pathname !== location.pathname) return;
    e.preventDefault();
    // The Specs section is hidden on these products: its links open the Dimensions panel at the top instead
    if (a.getAttribute('href') === '#specifications') { var s = document.querySelector('[data-hl-spec-open]'); if (s) s.click(); return; }
    open({ currentTarget: a });
  });
  // Sentences that sent shoppers down to the 2D planner or the Specs section now point to what replaced them
  [['.hl-pacc', 'or use the Island Planner below.', 'or open Preview in 3D at the top of this page.'],
    ['.hl-pfaq', 'The Island Planner on this page works it out for your exact length, and lets you compare layouts.', 'Preview in 3D at the top of this page works it out for your exact island length and shows the layout over a kitchen island.'],
    ['.hl-pfaq', 'See the technical drawing in the specifications for proportions.', 'The technical drawing is in Dimensions & specifications, at the top of this page.'],
    ['.hl-pfaq', 'See the specifications', 'See the dimensions']].forEach(function (r) {
    document.querySelectorAll(r[0] + ' p, ' + r[0] + ' a').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.indexOf(r[1]) !== -1) el.textContent = el.textContent.replace(r[1], r[2]);
    });
  });
  // "View in 3D" on the main photo; the theme may redraw its gallery when the variant changes, so it is put back
  var ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.8 20 7.4v9.2L12 21.2 4 16.6V7.4z"/><path d="M4 7.4 12 12l8-4.6M12 12v9.2"/></svg>';
  function pill() {
    var box = document.querySelector('.product-information media-gallery slideshow-container') || document.querySelector('main media-gallery slideshow-container');
    if (!box || box.querySelector('.hl-3d-pill')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'hl-3d-pill'; b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = ICON + '<span>View in 3D</span>';
    bind(b); box.appendChild(b);
  }
  pill();
  var gallery = document.querySelector('.product-information') || document.querySelector('main');
  if (gallery && window.MutationObserver) {
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(pill, 120); }).observe(gallery, { childList: true, subtree: true });
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
})();
